import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NavigationBarWhiteComponent } from '@app/components/shared/navigation-bar-white/navigation-bar-white.component';
import { LoadingTableComponent } from '@app/components/shared/loading-table/loading-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FooterStyleDefaultComponent } from '@app/components/shared/footer-style-default/footer-style-default.component';
import { HeaderStyleDefaultComponent } from '@app/components/shared/header-style-default/header-style-default.component';
import { LayoutStyleDefaultComponent } from '@app/components/shared/layout-style-default/layout-style-default.component';
import { NavigationBarEmployeeConfigComponent } from '@app/components/util/navigation-bar-employee-config/navigation-bar-employee-config.component';
import { NgSelect2Module } from 'ng-select2';
import { InputFileRectangleComponent } from './input-file-rectangle/input-file-rectangle.component';
import { ResumeSendModalModule } from '../resume-send-modal/resume-send-modal.module';
import { DirectivesModule } from '@app/directives/directives.module';
import { PipesModule } from '@app/pipes/pipes.module';
import { LayoutStyleWithoutNavigationComponent } from './layout-style-without-navigation/layout-style-without-navigation.component';
import { NavigationBarEmployeeSubstitutionComponent } from '../util/navigation-bar-employee-substitution/navigation-bar-employee-substitution.component';
import { ModalBarEmployeeSubstitutionComponent } from '../util/modal-bar-employee-substitution/modal-bar-employee-substitution.component';
import { FilterAvailibityComponent } from '../employer-search-talent/filter-availibity/filter-availibity.component';
import { LayoutStyleMenuLateralComponent } from './layout-style-menu-lateral/layout-style-menu-lateral.component';
import { HeaderStyleMenuLateralComponent } from './header-style-menu-lateral/header-style-menu-lateral.component';
import { EmployerUserModalModule } from '../employer-user-modal/employer-user-modal.module';
import { LayoutComplaintRegisterComponent } from '../layout-complaint-register/layout-complaint-register.component';

const routes: Routes = [];

@NgModule({
  imports: [
    EmployerUserModalModule,
    ResumeSendModalModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelect2Module,
    RouterModule.forChild(routes),
    DirectivesModule,
    PipesModule,
  ],
  declarations: [
    FilterAvailibityComponent,
    FooterStyleDefaultComponent,
    HeaderStyleDefaultComponent,
    HeaderStyleMenuLateralComponent,
    LayoutStyleDefaultComponent,
    LayoutStyleWithoutNavigationComponent,
    LayoutStyleMenuLateralComponent,
    LayoutComplaintRegisterComponent,
    LoadingTableComponent,
    NavigationBarWhiteComponent,
    NavigationBarEmployeeConfigComponent,
    NavigationBarEmployeeSubstitutionComponent,
    ModalBarEmployeeSubstitutionComponent,
    InputFileRectangleComponent,
  ],
  exports: [
    FilterAvailibityComponent,
    FooterStyleDefaultComponent,
    HeaderStyleDefaultComponent,
    HeaderStyleMenuLateralComponent,
    LayoutStyleDefaultComponent,
    LayoutStyleWithoutNavigationComponent,
    LayoutStyleMenuLateralComponent,
    LoadingTableComponent,
    NavigationBarWhiteComponent,
    NavigationBarEmployeeConfigComponent,
    NavigationBarEmployeeSubstitutionComponent,
    ModalBarEmployeeSubstitutionComponent,
    InputFileRectangleComponent,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelect2Module,
    DirectivesModule,
    PipesModule
  ],
  providers: [CurrencyPipe]

})
export class SharedModule { }